module.exports = __webpack_public_path__ + "Card-Example2.png";